import Messager from './Messager'
import Faye from 'faye';

var client = new Faye.Client('http://www.rhlm.co.za/message');
//var client = new Faye.Client('http://102.133.234.18:443/');

class FayeMessager extends Messager {
	subscribe(topic, fn) {
    client.subscribe(topic, fn);
  }

  unsubscribe(topic) {
    client.unsubscribe(topic);
  }

  publish(topic, info) {
		client.publish(topic, info);
	}
}

export default FayeMessager;


// WEBPACK FOOTER //
// ./src/components/SqTasks/task/FayeMessager.js